/* eslint-disable */
import "./EditRecord.js";
import { uniqueId } from "lodash";
import { closeModalPopupEvent } from "../../sharedComponents/modalPopup/events";

(function ($) {
    $.widget("ep.form_record_edit_popup", {
        options: {
            ajax: ep.common.ajax,
            post: ep.common.post,
            get: ep.common.get,
            resources: {
                closeBtnToolTip: ""
            },
            getPreviewPostData: function () { },
            urls: {
                newFormRecord: "/FormRecords/New",
                getFormRecord: "/FormRecords/Edit",
                createFormRecord: "/FormRecords/Create",
                updateFormRecord: "/FormRecords/Update"
            },
            editRecordContainerClass : 'edit_record_container',
            openedCustomFormPopupClass: "opened-custom-form-popup",
            showPreview: false,
            renderInOverlay: false,
        },

        _create: function () {
            var _this = this;

            $(this.element).click(function (e) {

                _this._trigger('afterClick', null, null);
                var formID = $(this).attr('formID');
                var recordID = $(this).attr('recordID');

                _this._createPopup();

                _this._createEditWidget(formID, recordID);
                return false;
            });
        },

        _createPopup: function () {
            var _this = this;
            this.lastScrollTop = $(window).scrollTop();
            this.reachedTop = true;

            // Create popup element.
            this.$body = $('body');
            this.$body.addClass(this.options.openedCustomFormPopupClass);
            this.$body.append('<div class="overlay-layer-editrecord"/>');
            var previewHtml = '';
            if (this.options.showPreview) {
                previewHtml = '<div class="preview_triangle"></div>';
            }
            this.popupElement = $('<div class="edit_record_popup popUp-holder-arrow ui-front formedit ui-dialog ui-widget ui-widget-content"/>').append(previewHtml).append('<div class="closePopUp" title="' + this.options.resources.closeBtnToolTip + '"></div><div tabindex="0" class="' + this.options.editRecordContainerClass + '"></div>')
                .css({
                    position: 'absolute',
                    zIndex: 10001,
                    top: 0,
                    marginBottom: 30,
                    left: 50 + '%',
                    display: 'block',
                    visibility: 'hidden'
                })
                .appendTo(this.options.renderInOverlay ? '.overlay-layer-editrecord' : 'body');
            this.overlay = $('.overlay-layer-editrecord');
            this.editRecordElement = $('.edit_record_container', this.popupElement);
            this.editRecordElement.epAddTabbableInsidePopup();
            this.closeBtn = $(".closePopUp", this.popupElement);
            $(window).scroll(function () {
                _this._setWithScroll();
            });
            this.closeBtn.click(function () {
                _this._closePopup();
            });

            this.ns = uniqueId(".jquery_edit_record_popup");
            $.subscribe(closeModalPopupEvent + this.ns, () => _this._closePopup());
        },

        _createEditWidget: function (formID, recordID) {
            var _this = this;

            ep.forms.utility.closePopups();

            var options = $.extend({}, this.options);
            options = $.extend(options, {
                formID: formID,
                recordID: recordID,
                save: function (event, data) { // Bubble up 'save' event. 
                    _this._trigger('save', null, data);
                    _this._closePopup();
                },
                postBack: function (evt, data) {
                    _this._setPosition();
                },
                closePopUp: function (evt, data) {

                    _this._closePopup();
                }
            });
            this.editRecordElement.form_record_edit(options); //append widget with content
        },

        _setPosition: function () {
            var docHeight = $(window).height();
            var top = 20;

            if ($(window).scrollTop() > 20) {
                top = $(window).scrollTop() + 10;
                this.reachedTop = false;
            }

            this.popupElement.css({
                marginLeft: - (this.popupElement.width()) / 2,
                visibility: 'visible',
                top: top
            });
            if (this.options.showPreview) {
                var focusableElement = $('.preview-style', this.popupElement).find(':focusable');
                focusableElement.attr('tabindex', '-1');
            }
            var focusableElement = $('.' + this.options.editRecordContainerClass, this.popupElement).find(':tabbable');
            if (focusableElement[0]) {
                focusableElement[0].focus();
            }

            this._trigger('shownPopUp');
        },

        _setWithScroll: function () {
            var currentScrollTop = $(window).scrollTop();
            var isUpScroll = currentScrollTop < this.lastScrollTop;

            if (isUpScroll && !this.reachedTop) {

                var top = currentScrollTop + 20;
                this.popupElement.css({ top: top });

                if (currentScrollTop < 20) {
                    this.reachedTop = true;
                }
            }

            this.lastScrollTop = currentScrollTop;
        },

        _refresh: function () {
        },

        _closePopup: function () {

            if(this.ns){
                $.unsubscribe(this.ns);
            }
            this._trigger('closePopUp');
            this._destroyCurrentEditWidget();
        },

        _destroyCurrentEditWidget: function () {
            if (this.editRecordElement != undefined) {
                this.editRecordElement.form_record_edit('destroy');
                this.editRecordElement = null;
            }

            if (this.popupElement != undefined) {
                this.$body.removeClass(this.options.openedCustomFormPopupClass);
                this.popupElement.remove();
                this.overlay.remove();
                this.popupElement = null;
            }
        },

        destroy: function () {
            this._destroyCurrentEditWidget();

            // Call the base destroy function
            $.Widget.prototype.destroy.call(this);
        }
    });
})(jQuery);

/* eslint-enable */
